import React from 'react'
import { parseHostname } from '@ta-interaktiv/parse-hostname'

export const PrivacyPolicyLink = () => {
  const domain = parseHostname().publicationDomain
  return (
    <a
      href={`https://abo.${domain}/tamstorefront/terms/register`}
      className={'privacyPolicyLink'}
    >
      Datenschutzerklärung von Tamedia
    </a>
  )
}
